import { useEffect, useState } from "react";

import { APPS_MANIFEST_URL } from "../constants";
import type { AppEntry, AppsManifest } from "../types";

interface AppsState {
  apps: AppEntry[];
  isLoading: boolean;
  error: Error | null;
}

export function useApps(): AppsState {
  const [state, setState] = useState<AppsState>({
    apps: [],
    isLoading: true,
    error: null,
  });

  useEffect(() => {
    let cancelled = false;

    fetch(APPS_MANIFEST_URL, { cache: "no-store" })
      .then(async res => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return (await res.json()) as AppsManifest;
      })
      .then(data => {
        if (cancelled) return;
        setState({
          apps: Array.isArray(data.apps) ? data.apps : [],
          isLoading: false,
          error: null,
        });
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setState({
          apps: [],
          isLoading: false,
          error: err instanceof Error ? err : new Error(String(err)),
        });
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
